import styled, { keyframes } from "styled-components";
// import Img from "@assets/img";
import { sm } from "src/styles/constants";

// export const Wrapper = styled.div`
//   position: relative;
//   max-width: 100%;
//   height: 100%;
//   display: flex;
//   background-image: url(${Img.bgDesktop});
//   background-repeat: no-repeat;
//   background-size: cover;
//   @media screen and (max-width: 768px) {
//     flex-direction: column;
//     background-image: url(${Img.bgMobile});
//   }
//   .activeBg {
//     background: #101355;
//   }
// `;

export const Wrapper = styled.div`
  position: relative;
  max-width: 100%;
  height: 100%;
  display: flex;
  background-repeat: no-repeat;
  background-size: cover;
  @media screen and (max-width: 768px) {
    flex-direction: column;
  }
  .activeBg {
    background: var(--secondary-label-color);
  }
`;

export const Top = styled.div`
  display: flex;
  gap: 40px;
  @media (max-width: 1440px) {
    display: flex;
    flex-direction: column;
  }
`;

export const ContainerNavigate = styled.div`
  width: 100%;
  display: none;
  @media screen and (max-width: 768px) {
    position: sticky;
    top: 0;
    background-color: transparent;
    z-index: 99;
    display: block;
  }
`;
export const TabProfile = styled.div`
  display: none;
  @media screen and (max-width: 768px) {
    display: block;
  }
`;
export const TabContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 15px;
  .active {
    color: #00e5e8;
    border-bottom: 1px solid #00e5e8;
    font-weight: 700;
  }
  > div {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #b3b3b3;
    padding: 10px 0;
    border-bottom: 1px solid #b3b3b3;
  }
`;
export const ContainerWrapper = styled.div`
  width: w-full;
  padding: 15px 40px;
  display: flex;
  flex-direction: column;
  .title {
    margin: 0px 0 30px;
    font-size: 30px;
    font-weight: 700;
    color: #fff;
  }

  @media screen and (max-width: 768px) {
    padding: 8px;
    width: 100%;
  }
  @media screen and (max-width: 768px) {
    .hidden {
      display: none;
    }
    .active {
      display: block;
    }
  }
`;

export const Title = styled.div`
  width: 100%;
  font-size: 30px;
  font-weight: 700;
  background: #eaf0d5;
  color: var(--placeholder-color);
    @media (max-width: 768px) {
    font-size: 20px;
    line-height: 24px;
    margin-top: 0;
    margin-bottom: 4px;
  }

  &.raffle_result_title {
    margin-top: 16px;
  }
`;

export const SubTitle = styled.p`
  font-size: 14px;
  line-height: 18px;
  font-weight: 400;
  color: #b3b3b3;
  margin-bottom: 20px;
  @media (max-width: 768px) {
    font-size: 12px;
    line-height: 16px;
  }
`;

export const RaffleContainer = styled.div`
  p {
    margin: 0 0 10px 0;
    font-size: 30px;
    font-weight: 700;
    color: #fff;
  }
  @media (max-width: 768px) {
    p {
      font-size: 20px;
    }
  }
  h1 {
    font-size: 24px;
    font-weight: 700;
    margin-bottom: 35px;
  }
`;

export const RaffleList = styled.div`
  .swiper {
    position: relative;
  }
`;

export const TableList = styled.div`
  width: 100%;
  display: flex;
  /* align-items: center; */
  justify-content: center;
  margin-top: 30px;
  gap: 20px;
  @media screen and (max-width: 1024px) {
    flex-direction: column;
  }
`;

export const DetailContainer = styled.div`
  width: 100%;
  margin-top: 35px;
`;

export const BannerImg = styled.img`
  cursor: pointer;
  width: 100%;
  aspect-ratio: 4 / 1;
  object-fit: cover;
    @media (max-width: 768px) {
      aspect-ratio: 1;
  }
`;

export const ButtonStyled = styled.button`
  color: #fff;
  background: linear-gradient(113.96deg, #00ffed 0%, #00b8ba 100%);
  text-align: center;
  outline: none;
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  padding: 7px 33px;
  border-radius: 6px;
  border: none;
  width: 150px;
  margin: 20px auto;
  border-radius: 12px;
`;

export const FilterWapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  // height: 100%;
  margin: 1rem 5rem 1rem 1rem;

  .search_row {
    display: flex;
    gap: 1.5rem;
    align-items: baseline;
    flex-wrap: wrap;
  }
  svg{
    display: none;
  }

  .raffle_name_input {
    flex: 1;
    min-width: 300px;
    position: relative;
    
    input {
      border: 1px solid #ccd0c3 !important;
      border-radius: 6px;
      padding: 16px 16px 16px 48px;
      font-size: 14px;
      background: #f2f6e6 !important;
      width: 100%;
      height: 54px;
      box-sizing: border-box;
      box-shadow: none !important;
      &::placeholder {
        color: #343535 !important;
        font-weight: 400;
        font-size: 14px;
      }
      
      &:focus {
        outline: none;
        border-color: #d1d5db !important;
        background: white;
        color: #34353579 !important;
      }
    }

    &::before {
      content: "";
      position: absolute;
      left: 16px;
      top: 50%;
      transform: translateY(-90%);
      width: 24px;
      height: 24px;
      background: url("/game-controller-2.png") no-repeat center;
      background-size: contain;
      z-index: 1;
    }
  }

  .date_input {
    flex: 0 0 auto;
    min-width:21%;
    position: relative;
    
    input {
      border: 1px solid #ccd0c3 !important;
      border-radius: 6px;
      padding: 16px 16px 16px 48px;
      font-size: 14px;
      background: #f2f6e6 !important;
      width: 100%;
      height: 54px;
      box-sizing: border-box;
      box-shadow: none !important;
      
      &::placeholder {
        color: #343535 !important;
        font-weight: 400;
        font-size: 14px;
      }
      
      &:focus {
        outline: none;
        border-color: #d1d5db;
        background: white;
      }
    }

    &::before {
      content: "";
      position: absolute;
      left: 16px;
      top: 50%;
      transform: translateY(-83%);
      width: 24px;
      height: 24px;
      background: url("/arrow-right.png") no-repeat center;
      background-size: contain;
      z-index: 1;
    }
  }

  

  .search_button {
    background: #4b975b !important;
    color: white;
    border: none;
    border-radius: 6px;
    padding: 16px 32px;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    transition: background-color 0.2s;
    height: 54px;
    min-width: 120px;
    
    &:hover {
      background: #5a8a5d;
    }
    
    &:focus {
      outline: none;
      box-shadow: 0 0 0 2px rgba(107, 159, 110, 0.2);
    }
  }

  .raffle_table {
    min-height: calc(100vh - 335px);
    width: 100%;
    margin-top: 20px;
  }

  @media (max-width: 1024px) {
    .search_row {
      display: none;
    }
  }

  @media (max-width: ${sm}) {
    .search_row {
      flex-direction: column;
      gap: 12px;
    }

    .raffle_name_input,
    .date_input {
      width: 100%;
      min-width: unset;
    }

    .search_button {
      width: 100%;
    }
  }
`;

export const ContainerLeaderBoard = styled.div<{
  marginTop: string;
}>`
  margin-top: ${(props) => props.marginTop};
  height: 100%;
  position: relative;
  z-index: 999 !important;
  @media (max-width: 932px) and (max-height: 430px) {
    margin-top: 20px;
  }
`;
export const TitleLeaderBoard = styled.div<{
  backgroundImage: string;
  height: string;
}>`
  background-image: ${(props) => props.backgroundImage};
  background-size: cover;
  background-position: center;
  height: ${(props) => props.height}px;
  padding: 10px 40px;
  text-align: center;
  color: white;
  font-weight: 700;
  position: relative;
  border-top-left-radius: 25px;
  border-top-right-radius: 25px;
`;

const cascadeOpen = keyframes`
  0% {
    opacity: 0;
    transform: translateY(-20px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
`;

const cascadeClose = keyframes`
  0% {
    opacity: 1;
    transform: translateY(0);
  }
  100% {
    opacity: 0;
    transform: translateY(-20px);
  }
`;

export const ContentLeaderBoard = styled.div<{
  open: boolean;
}>`
  position: relative;
  bottom: 54px;
  border-radius: 25px;
  background: linear-gradient(to right, #000000, #737373);
  padding: 20px;
  /* Add animation here */
  animation: ${({ open }) => (open ? cascadeOpen : cascadeClose)} 0.5s
    ease-in-out forwards;
`;

export const ContentTitle = styled.div`
  text-align: center;
  margin-bottom: 10px;
  font-weight: 700;
  font-size: 14px;
`;

export const LeaderBoard = styled.div`
  max-height: 330px;
  overflow-y: auto;
  position: relative;
  padding: 10px 0px;
  background: transparent;
  &::-webkit-scrollbar {
    width: 8px;
  }
  &::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 10px;
  }
  &::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 6px;
  }
  &::-webkit-scrollbar-thumb:hover {
    background: #555;
  }
  &::-webkit-scrollbar-button {
    background-color: transparent;
  }
  @media (max-width: 768px) {
    max-height: 450px;
  }
`;
export const RankOfUser = styled.div<{ bgColor: string }>`
  background-color: ${(props) => props.bgColor};
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 25px;
  border-radius: 30px;
  margin-bottom: 8px;
`;
export const InfoRank = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
`;
export const UserName = styled.div`
  font-size: 14px;
  font-weight: 500;
`;
export const RankNumber = styled.div<{ color: string; rankNumber: number }>`
  text-align: center;
  border: 3px solid white;
  background-color: ${(props) => props.color};
  border-radius: 50%;
  width: 25px;
  height: 25px;
  color: white;
  position: relative;
  &::before {
    content: "${(props) => props.rankNumber}";
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 22px;
    height: 22px;
    font-size: 10px;
    font-weight: 700;
    color: #fff;
    right: 8px;
    top: -13px;
    z-index: 3;
  }
`;
export const Medal = styled.img`
  width: 20px;
  height: 20px;
  position: absolute;
  left: 18px;
  margin-top: -17px;
`;
export const UserPoint = styled.div`
  font-size: 12px;
`;
export const ViewAllButton = styled.button`
  display: flex;
  justify-content: center;
  border: none;
  color: white;
  background-color: rgb(252, 18, 80);
  padding: 5px;
  border-radius: 2px;
  font-weight: 500;
`;

export const ReferButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: end;
  border: none;
  color: white;
  background-color: rgb(147, 195, 65);
  padding: 4px 10px;
  font-weight: 500;
  border-radius: 25px;
`;

export const HeroTitle = styled.div`
  width: 100%;
  font-size: 28px;
  font-weight: 700;
  color: black;
  font-kerning: none;
  text-align: start;
  line-height: 1.5;
  @media (max-width: 768px) {
    margin-top: 0;
    margin-bottom: 4px;
    text-align: left;
  }
  &.raffle_result_title {
    margin-top: 16px;
  }
`;

export const RaffleResultsTable = styled.div`
  width: 100%;
  background: white;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);

  table {
    width: 100%;
    border-collapse: collapse;

    thead {
      background: #4a5568;
      color: white;

      th {
        padding: 16px 20px;
        text-align: left;
        font-weight: 600;
        font-size: 14px;
        border: none;
      }
    }

    tbody {
      tr {
        border-bottom: 1px solid #e2e8f0;
        background: white;

        &:nth-child(even) {
          background: #f8f9fa;
        }

        &:hover {
          background: #f1f5f9;
        }

        td {
          padding: 16px 20px;
          font-size: 14px;
          color: #2d3748;
          vertical-align: middle;
          border: none;

          .raffle-name-cell {
            display: flex;
            align-items: center;
            gap: 12px;

            .raffle-icon {
              width: 32px;
              height: 32px;
              border-radius: 4px;
              object-fit: cover;
            }

            span {
              font-weight: 500;
            }
          }

          .view-details-btn {
            background: #eaf0d5 !important;
            color: #4b975b;
            border: none;
            padding: 6px 16px;
            border-radius: 4px;
            font-size: 12px;
            font-weight: 600;
            cursor: pointer;
            transition: background-color 0.2s;
            border-radius: 8px;

            &:hover {
              background: #c8e6c8;
            }
          }
        }
      }
    }
  }

  @media (max-width: 768px) {
    table {
      thead th,
      tbody td {
        padding: 12px 16px;
        font-size: 12px;
      }

      .raffle-name-cell {
        gap: 8px;

        .raffle-icon {
          width: 24px;
          height: 24px;
        }
      }

      .view-details-btn {
        padding: 4px 12px;
        font-size: 11px;
      }
    }
  }
`;

export const HeroSectionContainer = styled.section`
  display: flex;
  flex-direction: row;
  align-items: center;
  position:relative;
  justify-content: space-between;
  padding: 40px;
  // margin-top: 32px;
  color: var(--text-color);
  text-align: center;
  background: var(--tertiary-color, none);
  background-image: var(--hero-bg-image, none);
  background-size: cover;
  background-repeat: no-repeat;
  border-bottom: 3px solid transparent;
  border-image-slice: 1;
  @media (max-width: 768px) {
    flex-direction: column;
    margin-top: 0;
    justify-content: left;
    align-items: start;
  }
`;

// export const Title = styled.h1`
//   font-size: 2.5rem;
//   margin-bottom: 20px;
// `;

export const Subtitle = styled.h2`
  font-size: 1rem;
  font-weight: 300;
  // margin-bottom: 30px;
  text-align: right;
  color: var(--subtitle-color);
  @media (max-width: 768px) {
    text-align: left;
    font-size: 1rem;
  }
`;

export const CallToActionButton = styled.button`
  padding: 10px 20px;
  font-size: 1rem;
  color: white;
  background-color: #ff4757;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  transition: background-color 0.3s;

  &:hover {
    background-color: #ff6b81;
  }
`;

export const ResultHeroTitle = styled.div`
  position:relative;
  width: 100%;
  font-size: 3rem;
  font-weight: 700;
  color: #343535;
  font-kerning: none;
  text-align: justify;
  margin: 4rem 0rem 0rem 1rem;
  line-height: clamp(24px, 6vw, 80px);
  @media (max-width: 768px) {
    margin-top: 0;
    margin-bottom: 4px;
  }

  &.raffle_result_title {
    margin-top: 16px;
  }
`;

export const bodyWrapper = styled.div`
  width: 100%; 
  padding: 20px;
  background: #f9f9f9;
  border-top: 1px solid #eee;
`;

// Raffle Result Detail Styles
export const RaffleResultDetailContainer = styled.div`
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
  
  @media (max-width: 768px) {
    padding: 0;
  }
`;

export const DesktopView = styled.div`
  display: block;
  
  @media (max-width: 768px) {
    display: none;
  }
`;

export const MobileView = styled.div`
  display: none;
  
  @media (max-width: 768px) {
    display: block;
    background: #f5f5dc;
    min-height: 100vh;
  }
`;

export const RaffleHeader = styled.div`
  margin-bottom: 24px;
`;

export const RaffleTitle = styled.h1`
  font-size: 32px;
  font-weight: 700;
  color: #2d3748;
  margin-bottom: 8px;
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const LeafIcon = styled.span`
  font-size: 28px;
`;

export const RaffleDuration = styled.p`
  font-size: 16px;
  color: #718096;
  margin: 0;
`;

export const ResultsTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  background: white;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
`;

export const TableHeader = styled.th`
  background: #4a5568;
  color: white;
  padding: 16px 20px;
  text-align: left;
  font-weight: 600;
  font-size: 14px;
  border: none;
  
  &:first-child {
    border-top-left-radius: 8px;
  }
  
  &:last-child {
    border-top-right-radius: 8px;
  }
`;

export const TableRow = styled.tr`
  border-bottom: 1px solid #e2e8f0;
  background: white;
  
  &:nth-child(even) {
    background: #f8f9fa;
  }
  
  &:hover {
    background: #f1f5f9;
  }
`;

export const TableCell = styled.td`
  padding: 16px 20px;
  font-size: 14px;
  color: #4a5568;
  border: none;
`;

export const RewardBadge = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: #ff8c42;
  color: white;
  padding: 6px 12px;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 600;
`;

export const NoRewardBadge = styled.div`
  display: inline-block;
  background: #e8f5e9;
  color: #6b9f6e;
  padding: 6px 12px;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 500;
`;

// Mobile Styles
export const MobileHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 16px;
  background: white;
  border-bottom: 1px solid #e2e8f0;
`;

export const MobileRaffleIcon = styled.div`
  width: 64px;
  height: 64px;
  flex-shrink: 0;
  background: #fff;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

export const MobileRaffleTitle = styled.h2`
  font-size: 18px;
  font-weight: 600;
  color: #2d3748;
  margin: 0;
  line-height: 1.4;
`;

export const AccordionContainer = styled.div`
  padding: 0 16px 16px;
`;

export const AccordionItem = styled.div`
  background: white;
  border-radius: 12px;
  margin-top: 16px;
  overflow: hidden;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
`;

export const AccordionHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px;
  cursor: pointer;
  user-select: none;
  border-bottom: 1px solid #f0f0f0;
  
  &:active {
    background: #f8f9fa;
  }
`;

export const AccordionDate = styled.div`
  font-size: 16px;
  font-weight: 600;
  color: #2d3748;
`;

export const AccordionIcon = styled.span<{ isExpanded: boolean }>`
  font-size: 12px;
  color: #718096;
  transition: transform 0.2s ease;
  transform: ${props => props.isExpanded ? 'rotate(180deg)' : 'rotate(0deg)'};
`;

export const AccordionContent = styled.div`
  padding: 0 20px 16px;
  animation: slideDown 0.2s ease;
  
  @keyframes slideDown {
    from {
      opacity: 0;
      transform: translateY(-10px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
`;

export const DetailRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 0;
  border-bottom: 1px solid #f0f0f0;
  
  &:last-child {
    border-bottom: none;
  }
`;

export const DetailLabel = styled.div`
  font-size: 14px;
  color: #718096;
  font-weight: 400;
`;

export const DetailValue = styled.div`
  font-size: 14px;
  font-weight: 500;
  text-align: right;
  
  &.daily {
    color: #6b9f6e;
    font-weight: 600;
  }
  
  &.duration {
    color: #6b9f6e;
  }
  
  &.number {
    color: #2d3748;
    font-weight: 600;
  }
  
  &.reward {
    color: #6b9f6e;
    font-weight: 600;
  }
`;